<script>
import Deal from '@/components/atoms/restaurant/Deal'
import { mapGetters } from 'vuex'
export default {
    name: 'Deals',
    components: { Deal },
    props: {
        restaurant: null,
        price: null,
        currency: {
            type: Object,
            default: () => {},
        },
    },
    computed: {
        ...mapGetters(['smDevice']),
        calculation() {
            return this.$cart?.calculation
        },
        promotions() {
            return this.calculation?.available_promotions || []
        },
        deliveryFeePromotions() {
            return this.promotions.filter((promotion) => promotion.delivery_fee_remission)
        },
        locationInfo() {
            return this.restaurant?.location_info || {}
        },
        restaurantBasedFreedeliveryLimit() {
            return this.locationInfo.delivery_price_limit || 0
        },
        promotionBasedFreedeliveryLimit() {
            return this.deliveryFeePromotions.reduce((p, c) => {
                if (p === null || p > c?.minimum_total) return c.minimum_total
                return p
            }, null)
        },
        hideRestaurantBasedDeliveryFeeNotification() {
            return (
                (this.restaurantBasedFreedeliveryLimit === 0 ||
                    (this.promotionBasedFreedeliveryLimit !== null &&
                        this.promotionBasedFreedeliveryLimit <=
                            this.restaurantBasedFreedeliveryLimit)) &&
                !(this.calculation.delivery_fee_discount > 0 && !this.calculation.promotion)
            )
        },
        deliveryFreeOfCharge() {
            return (
                (this.locationInfo.delivery_price || 0) === 0 ||
                this.restaurantBasedFreedeliveryLimit === 0
            )
        },
        restaurantBasedFreeDeliveryGranted() {
            return (
                this.calculation.price_delivery === 0 && this.restaurantBasedFreedeliveryLimit > 0
            )
        },

        toGetRestaurantBasedFreeDelivery() {
            return this.$options.filters.toCurrency(
                this.restaurantBasedFreedeliveryLimit - this.price,
                this.currency?.locale,
                this.currency?.currency_code
            )
        },

        deliverySaved() {
            return this.$options.filters.toCurrency(
                this.calculation.delivery_fee_discount || this.locationInfo.delivery_price || 0,
                this.currency?.locale,
                this.currency?.currency_code
            )
        },
        userSaved() {
            return this.$options.filters.toCurrency(
                this.calculation.user_discount || 0,
                this.currency?.locale,
                this.currency?.currency_code
            )
        },
    },
    methods: {
        promotionDiscount(promotion) {
            return promotion.discount_type === 'percentage'
                ? `${promotion.discount_value}%`
                : this.$options.filters.toCurrency(
                      promotion.discount_value,
                      this.currency?.locale,
                      this.currency?.currency_code
                  )
        },
        promotionCompleted(promotion) {
            return this.calculation.promotion?.id === promotion.id
        },
        toGetDiscount(promotion) {
            return this.$options.filters.toCurrency(
                promotion.minimum_total - this.price,
                this.currency?.locale,
                this.currency?.currency_code
            )
        },
        showDiscountPromotion(promotion) {
            return (
                (!this.calculation.promotion || //no active promotion
                    this.promotionCompleted(promotion) || //given promotion is the active promotion
                    promotion.minimum_total - this.price > 0) && //given promotion still not completed
                !this.promotions.find(
                    // promotion that never be active
                    (dPromotion) =>
                        dPromotion.minimum_total < promotion.minimum_total &&
                        dPromotion.discount_value >= promotion.discount_value
                ) &&
                !(
                    !this.calculation.promotion &&
                    this.calculation.delivery_fee_discount > 0 &&
                    promotion.discount_value === 0 &&
                    promotion.delivery_fee_remission
                )
            )
        },
    },
}
</script>

<template lang="pug">
.card.border-radius-sm.mb-4.flat-card(v-if="!hideRestaurantBasedDeliveryFeeNotification || promotions.length")
    .card-body.border-radius-sm.py-4(:class="{'px-5': smDevice}")
        h4 {{$t('cart.unlock_deals')}}
        template(v-if="!hideRestaurantBasedDeliveryFeeNotification")
            deal(
                v-if="deliveryFreeOfCharge"
                completed)
                template(v-slot:completed) {{$t(`restaurant.free_delivery`) }}
            deal(
                :completed="restaurantBasedFreeDeliveryGranted"
                v-else)
                template(v-slot:deal) {{$t(`cart.deals.free_delivery`, { price: toGetRestaurantBasedFreeDelivery } ) }}
                template(v-slot:completed) {{$t(`cart.deals.free_delivery_completed`, { saved: deliverySaved } ) }}
        deal(
            v-for="promotion in promotions"
            v-if="showDiscountPromotion(promotion)"
            :completed="promotionCompleted(promotion)"
            :key="`promotion-${promotion.id}`")
            template(v-slot:deal)
                template(v-if="promotion.discount_value === 0")  {{$t(`cart.deals.free_delivery`, { price: toGetDiscount(promotion) } ) }}
                template(v-else) {{$t(`cart.deals.discount`, { price:  toGetDiscount(promotion), discount:  promotionDiscount(promotion) }, promotion.delivery_fee_remission ? 0 : 1 ) }}
            template(v-slot:completed) 
                template(v-if="promotion.discount_value === 0") {{$t(`cart.deals.free_delivery_completed`, { saved: userSaved } ) }}
                template(v-else) {{$t(`cart.deals.discount_completed`, { discount:  promotionDiscount(promotion), saved: userSaved }, promotion.delivery_fee_remission ? 0 : 1  ) }}
</template>
